import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
  align-items: center;
  justify-content: center;
  background: #f3f3f3;
`;
